import { useEffect, useState } from "react";

import { baseAPI } from "../../services/api";
import { notification } from "../../services/helpers";
import { validatePhoneRequest } from "../requests";
import { endOfDay, isAfter } from "date-fns";
import { useActions } from "../provider";

const AUTH_STORAGE_KEY = "@actions/auth";

function getToken() {
  return JSON.parse(localStorage.getItem(AUTH_STORAGE_KEY) || "{}");
}

export function useAuthentication({ setIsLoading }) {
  const [auth, setAuth] = useState(getToken() || "");

  function handleUpdateAuthToken(tokenObj) {
    setAuth((auth) => {
      localStorage.setItem(
        AUTH_STORAGE_KEY,
        JSON.stringify({ ...auth, ...tokenObj })
      );

      return {
        ...auth,
        ...tokenObj,
      };
    });
  }

  function handleGenerateSmsToken(msisdn) {
    const smsToken = btoa(`${endOfDay(Date.now()).toISOString()}#${msisdn}`);

    setAuth((auth) => {
      localStorage.setItem(
        AUTH_STORAGE_KEY,
        JSON.stringify({ ...auth, smsToken })
      );

      return {
        ...auth,
        smsToken,
      };
    });
  }

  function isSmsTokenValid(msisdn) {
    const { smsToken } = getToken();

    if (!smsToken || !msisdn) return false;

    const [date, tokenMsisdn] = atob(smsToken).split("#");

    if (isAfter(Date.now(), new Date(date))) return false;

    return msisdn === tokenMsisdn;
  }

  async function handleValidatePhone({ phone, channel, onValidate = () => {}, publicToken }) {
    try {
      setIsLoading(true);
      const response = await validatePhoneRequest(phone, channel);
      const { code, accessToken, msg, authenticated, refreshToken } = response?.data;

      if (!authenticated || !accessToken) return notification("error", msg);

      
      localStorage.clear();
      sessionStorage.clear();
      setAuth({});

      const authTokens = { accessToken, refreshToken, publicToken };
      handleUpdateAuthToken(authTokens);
      onValidate(authTokens)
    } catch (error) {
      notification("error", "Erro ao validar o telefone");
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    baseAPI.interceptors.request.use((config) => {
      const token = getToken();
      if (!!token) {
        config.headers.Authorization = `Bearer ${token.accessToken}`;
      }

      return config;
    });

    baseAPI.interceptors.response.use((response) => {
      if (response.status === 401) {
        // TODO: Make refresh token method
        console.log("REFRESH TOKEN");
      }

      return response;
    });
  }, []);

  return {
    handleValidatePhone,
    handleUpdateAuthToken,
    handleGenerateSmsToken,
    authToken: auth?.accessToken,
    refreshToken: auth?.refreshToken,
    publicToken: auth?.publicToken,
    isSmsTokenValid,
  };
}
